import {container} from "tsyringe";
import { ActivityApiRepository } from '../../repositories/api/ActivityApiRepository';
import ApiService from '../../services/ApiService';
import { ActivityMapper } from '@/data/persistences/mappers/ActivityMapper';
import { ActivityEndpoint } from '../../endpoints/horde/ActivityEndpoint';
import { ActivityPresenter } from '@/app/ui/presenters/ActivityPresenter';

export class ActivityComponent {
  public static init() {
    container.register<ActivityApiRepository>(ActivityApiRepository, {
      useFactory: d => {
        return new ActivityApiRepository(
          d.resolve(ApiService),
          d.resolve(ActivityMapper),
          d.resolve(ActivityEndpoint)
        )
      }
    });
    container.register<ActivityMapper>(ActivityMapper, {
      useClass: ActivityMapper
    });
    container.register<ActivityPresenter>(ActivityPresenter, {
      useFactory: d => {
        return new ActivityPresenter(d.resolve(ActivityApiRepository));
      }
    });
  }
}

